import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { WellDetailsModel } from './_models/well-details-model';
import { AdminWellSearch } from './_models/admin-well-search';
import { MatDialog } from '@angular/material/dialog';
import { EditFormationsDialogComponent } from './edit-formations-dialog/edit-formations-dialog.component';
import { Formation } from './_models/formation';
import { APIOperationResult } from './_models/apioperation-result';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';

import { FormationsForWellResponseModel } from './_models/formations-for-well-response-model';
import { FormationsForWellRequestModel} from './_models/formations-for-well-request-model';


@Injectable({
  providedIn: 'root'
})
export class UserWellsService {

  public isWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public result: Subject<Array<WellDetailsModel>> = new Subject<Array<WellDetailsModel>>();

  public detailsWell: Subject<WellDetailsModel> = new Subject<WellDetailsModel>();

  public foundUicWell: BehaviorSubject<WellDetailsModel> = new BehaviorSubject<WellDetailsModel>(null);

  public updateFormationsIsWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(protected httpClient: HttpClient,
    private dialog: MatDialog
  ) {
  }


  public handleError(errorResponse: HttpErrorResponse) {
    var ret: string = "An error occurred while attempting to communicate with the server.";

    return throwError(ret);
  }

  public GetWells() {

    var _this = this;
    this.isWorking.next(true);

    var inputParams = {};

    this.httpClient.get("api/well", inputParams).pipe(catchError(this.handleError)).subscribe((result: any) => {

      this.isWorking.next(false);

      this.result.next(result);
    });
  }

  public onWellDataUpdate(): Observable<Array<WellDetailsModel>> {
    return this.result.asObservable();
  }

  public onDetailsWellUpdate(): Observable<WellDetailsModel> {
    return this.detailsWell.asObservable();
  }

  public LoadDetailsWell(wellId: number) {
    this.isWorking.next(true);

    var inputParams = {};

    if (wellId != null) {

      this.httpClient.get("api/well/" + wellId, inputParams).pipe(catchError(this.handleError)).subscribe((result: any) => {

        this.isWorking.next(false);

        this.detailsWell.next(result);
      });
    }
    else {
      this.detailsWell.next(null);
    }
  }

  public LoadDetailsWellByUIC(uic: string) {
    this.isWorking.next(true); 

    var inputParams = {};

    this.httpClient.get("api/well/uic/" + uic, inputParams).pipe(catchError(this.handleError)).subscribe((result: any) => {

      this.isWorking.next(false);

      this.detailsWell.next(result);
    });
  }

  public LoadDetailsWellByAPINumber(apiNumber: string) {
    this.isWorking.next(true);

    var inputParams = {};

    this.httpClient.get("api/well/apinumber/" + apiNumber, inputParams).pipe(catchError(this.handleError)).subscribe((result: any) => {

      this.isWorking.next(false);

      this.detailsWell.next(result);
    });
  }

  public GetWellsAdminSearch(searchRequest: AdminWellSearch) {

    this.isWorking.next(true);

    this.httpClient.post("api/well/adminsearch", searchRequest).pipe(catchError(this.handleError)).subscribe((result: any) => {

      this.isWorking.next(false);

      this.result.next(result);
    });
  }

  public requestEditFormations(well: WellDetailsModel) {

    this.dialog.open(EditFormationsDialogComponent, {
      data: {
        well: well
      }
    }).afterClosed().subscribe((formations) => {
      //Refresh the well?

      this.updateWellFormations(well, formations).then((result: APIOperationResult) => {
        if (result.Success) {
          this.LoadDetailsWell(well.Id);
        }
        else {

          var message = "";

          for (var i = 0; i < result.Reasons.length; i++) {
            message = message + result.Reasons[i] + "\r\n";
          }

          this.dialog.open(MessageDialogComponent, {
            data: {
              title: "An error occurred while trying to save the formation data",
              message: message
            }
          });
        }
      },
      () => {
        //Do nothing?
      });
    });
  }

  public updateWellFormations(well: WellDetailsModel, formations: Array<Formation>) {
    var prom = new Promise((resolve, reject) => {

      if (formations != null) {
        var url = "api/well/" + well.Id + "/updateFormations";

        this.httpClient.post(url, formations
        ).pipe(catchError(this.handleError))
          .subscribe((result) => {

            if (result != null) {
              resolve(result);
            }
            else {
              reject();
            }
          });
      }
      else {
        reject();
      }
    });

    return prom;
  }

  //Retreives the set of formations that are associated with the wells with the specified IDs.
  public getFormationsForWellIds(formationsForWellRequestModel: FormationsForWellRequestModel) {
    var prom = new Promise((resolve, reject) => {
      var url = "api/well/formationsForWellIds";

        this.httpClient.post(url, formationsForWellRequestModel
        ).pipe(catchError(this.handleError))
          .subscribe((result) => {

            if (result != null) {
              resolve(result);
            }
            else {
              reject();
            }
          });
    });

    return prom;
  }
}
